import { render, staticRenderFns } from "./_PlayersReport.vue?vue&type=template&id=72330d21&scoped=true&"
import script from "./_PlayersReport.vue?vue&type=script&lang=ts&"
export * from "./_PlayersReport.vue?vue&type=script&lang=ts&"
import style0 from "./_PlayersReport.vue?vue&type=style&index=0&id=72330d21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72330d21",
  null
  
)

export default component.exports